/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { resetCognitiveAttempts$Json } from '../fn/cognitive-assessment/reset-cognitive-attempts-json';
import { ResetCognitiveAttempts$Json$Params } from '../fn/cognitive-assessment/reset-cognitive-attempts-json';
import { resetCognitiveAttempts$Plain } from '../fn/cognitive-assessment/reset-cognitive-attempts-plain';
import { ResetCognitiveAttempts$Plain$Params } from '../fn/cognitive-assessment/reset-cognitive-attempts-plain';

@Injectable({ providedIn: 'root' })
export class CognitiveAssessmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `resetCognitiveAttempts()` */
  static readonly ResetCognitiveAttemptsPath = '/cognitiveAssessment/{companyId}/resetAttempts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetCognitiveAttempts$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetCognitiveAttempts$Plain$Response(params: ResetCognitiveAttempts$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return resetCognitiveAttempts$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetCognitiveAttempts$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetCognitiveAttempts$Plain(params: ResetCognitiveAttempts$Plain$Params, context?: HttpContext): Observable<string> {
    return this.resetCognitiveAttempts$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetCognitiveAttempts$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetCognitiveAttempts$Json$Response(params: ResetCognitiveAttempts$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return resetCognitiveAttempts$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetCognitiveAttempts$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetCognitiveAttempts$Json(params: ResetCognitiveAttempts$Json$Params, context?: HttpContext): Observable<string> {
    return this.resetCognitiveAttempts$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
